// extracted by mini-css-extract-plugin
module.exports = {"container":"legacyOption_container__2av1i","title":"legacyOption_title__2zpKf","scenarioName":"legacyOption_scenarioName__s538F","infoReviewContribution":"legacyOption_infoReviewContribution__1D11x","selectCollaborator":"legacyOption_selectCollaborator__3Dgyd","hidden":"legacyOption_hidden__3bm5s","itemSelect":"legacyOption_itemSelect__19BNm","contentBtn":"legacyOption_contentBtn__2gdut","button":"legacyOption_button__3QucV"};
    if(module.hot) {
      // 1783592039287
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  